import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../utils/api';

function Register({ setIsAuthenticated, setUser }) {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [batch, setBatch] = useState('');
  const [batches, setBatches] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch available batches when component mounts
  useEffect(() => {
    const fetchBatches = async () => {
      try {
        setLoading(true);
        const response = await apiService.getActiveBatches();
        if (response.data.success) {
          setBatches(response.data.batches);
          if (response.data.batches.length > 0) {
            setBatch(response.data.batches[0].id);
          }
        } else {
          setError('Failed to load batches');
        }
      } catch (err) {
        setError('Error loading batches');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBatches();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!batch) {
      setError('Please select a batch');
      return;
    }

    try {
      // Always register as student
      const response = await apiService.register({ 
        username, 
        email, 
        password, 
        role: 'student',
        batchId: batch 
      });
      const data = response.data;

      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        setIsAuthenticated(true);
        setUser(data.user);
        navigate('/dashboard');
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error connecting to server');
      console.error(err);
    }
  };

  return (
    <div className="auth-container">
      <h2>Student Registration</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Username:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Select Batch:</label>
          {loading ? (
            <p>Loading batches...</p>
          ) : (
            <select 
              value={batch} 
              onChange={(e) => setBatch(e.target.value)}
              required
            >
              <option value="">Select a batch</option>
              {batches.map(b => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          )}
        </div>
        <button type="submit" className="auth-button" disabled={loading}>Register</button>
      </form>
      <p>
        Already have an account? <span onClick={() => navigate('/login')} className="auth-link">Login</span>
      </p>
    </div>
  );
}

export default Register;